import axios from '../http'
import global from '@/constants/Global.constants'

export default {
    getCaseList(params) { // 获取网页管理
        return axios.post(global.CMS_WY + '/simpleColumn/findWebSimpleColumn', params)
    }
}


// WEBPACK FOOTER //
// ./src/request/cms/wy.js